import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_6538_28854)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = { id: "clip0_6538_28854" }
const _hoisted_5 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'score',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M-0.00390625 0.75C-0.00390625 0.335786 0.33188 0 0.746094 0H3.63071C3.64947 0 3.66808 0.000689279 3.6865 0.0020439H10.3074C10.3253 0.000746236 10.3434 9.08375e-05 10.3615 9.08375e-05H13.2461C13.6603 9.08375e-05 13.9961 0.335877 13.9961 0.750091V3.63508C13.9961 5.49434 12.6001 7.02754 10.799 7.24363C10.3516 8.61283 9.1853 9.65688 7.74609 9.92989V12.5001H10.3615C10.7757 12.5001 11.1115 12.8359 11.1115 13.2501C11.1115 13.6643 10.7757 14.0001 10.3615 14.0001H7.02235C7.01363 14.0004 7.00488 14.0005 6.99609 14.0005C6.9873 14.0005 6.97855 14.0004 6.96983 14.0001H3.6307C3.21649 14.0001 2.8807 13.6643 2.8807 13.2501C2.8807 12.8359 3.21649 12.5001 3.6307 12.5001H6.24609V9.92989C4.80688 9.65688 3.6406 8.61283 3.19316 7.24363C1.39213 7.02754 -0.00390625 5.49434 -0.00390625 3.63508V0.75ZM2.88071 5.63422V1.5H1.49609V3.63508C1.49609 4.55007 2.07178 5.3306 2.88071 5.63422ZM11.1115 1.50009V5.63422C11.9204 5.3306 12.4961 4.55007 12.4961 3.63508V1.50009H11.1115Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_4, [
        _createElementVNode("rect", {
          width: "14",
          height: "14",
          fill: __props.color
        }, null, 8, _hoisted_5)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})